//Login Logos

//Home Logos
import { Tenant } from "../App";
import HomeLogo from "../assets/image/homeLogo.svg?react";

export const setLoginLogo = () => {
	switch (Tenant) {
		case "elemental":
			return (
				<img
					className="company-logo no-visual-search"
					style={{ width: "200px", position: "relative", left: "-10px" }}
					src={undefined}
					alt="Logo"
				/>
			);
		default:
			return null;
	}
};

export const setHomeLogo = () => {
	return <HomeLogo width={"35px"} />;
};

export const setDrawerlogo = (logo_link: any) => {
	if (logo_link) {
		return (
			<img
				className="drawer-logo no-visual-search"
				style={{ width: "90px", marginTop: "5px" }}
				src={logo_link}
				alt="Drawer_logo"
			/>
		);
	} else {
		return <></>;
	}
};
